export enum TripTypeEnum {
    Return = 'return',
    OneWay = 'one-way',
  }